var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.hkTipStyle)},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"info","placement":"right"}},[_c('div',{attrs:{"slot":"content"},domProps:{"innerHTML":_vm._s(_vm.infoText)},slot:"content"}),_c('el-button',{staticClass:"info-btn"},[_c('i',{staticClass:"el-icon-question"})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }